export const UPDATE_LOADING = 'UPDATE_LOADING';

export function updateLoading(field, data) {
    return {
        type: 'UPDATE_LOADING',
        payload: { field, data },
    };
}
